import React, { useState, useRef } from 'react';

import { ThemeProps, withTheme } from 'styled-components';

import { Container, Content, Name, Detail } from './styles';
import { CityAutoComplete } from 'models/cityAutoComplete';

type Value = CityAutoComplete;

export interface RenderProps {
  show: boolean;
  selectRef: React.RefObject<HTMLDivElement>;
  onClose: () => void;
  onChange: (value: Value) => void;
  testId?: string;
}

export interface BookingValue {
  name: string;
  detail: string;
}

interface Props extends ThemeProps<any> {
  label: string;
  detail: string;
  value?: BookingValue;
  children: (renderProps: RenderProps) => JSX.Element;
  onChange: (value: Value, isCity?: boolean) => void;
  disabled?: boolean;
  icon?: React.ReactNode;
  testId?: string;
}

const CitiesAutoCompleteSelect = ({ label, detail, value, disabled, children, onChange, icon, testId }: Props) => {
  const selectRef = useRef(null);

  const [showOptions, setShowOptions] = useState(false);

  const handleContainerClick = () => {
    setShowOptions(!showOptions);
  };

  const handleOptionsClose = () => {
    setShowOptions(false);
  };

  return (
    <Container ref={selectRef} active={!!value}>
      <Content onClick={() => (disabled ? null : handleContainerClick())} data-testid={testId}>
        <Name active={!!value}>{value?.name || label}</Name>
        <Detail active={!!value}>{value?.detail || detail}</Detail>
      </Content>
      {icon}
      {children({
        show: showOptions,
        onClose: handleOptionsClose,
        selectRef,
        onChange,
        testId,
      })}
    </Container>
  );
};

export default withTheme(CitiesAutoCompleteSelect);
